'use strict';

var sniff = require('./lib/ySniff.js');
var ready = require('./util/ready');
var extend = require('./util/extend');
var hyEnv = require('./env/hy');
var wechatEnv = require('./env/wechat');

var apis = require('./apis');
var events = require('./events');
var register = require('./register');
var bind = require('./bind');
var share = require('./share');

var getUrl = function getUrl() {
    return location.href.split('#')[0];
};
var envs = ['hy', 'wechat', 'h5'];

var cacheUrl = void 0;

module.exports = function (config, readyListenersCache) {
    var _this = this;

    var doReady = function doReady() {
        _this.isReady = true;
        readyListenersCache.forEach(function (fn) {
            return fn(_this.env);
        });
        readyListenersCache = [];
    };

    var wechatApis = [];

    this._apis = apis;

    // Init APIS

    var _loop = function _loop(key) {
        register.setUpFunction(_this, key, apis[key], config.debug, config.apiTimeout);
        _this[key] = register.common(_this, key, config.debug);
        envs.forEach(function (env) {
            if (apis[key][env]) {
                if (env === 'wechat') {
                    wechatApis.push(apis[key][env].key || key);
                }
                _this[env][key] = register.bind(_this, key, env);
            }
        });
    };

    for (var key in apis) {
        _loop(key);
    }

    // Bind Events
    bind.initCommonFns(this);
    envs.forEach(function (env) {
        bind['init' + env.replace(/\w/, function (a) {
            return a.toUpperCase();
        }) + 'Fns'](_this, events, config.debug);
    });

    var _loop2 = function _loop2(_key) {
        if (events.hasOwnProperty(_key)) {
            bind.initEventFns(_this, _key);
            envs.forEach(function (env) {
                return bind.initEventFns(_this, _key, env);
            });
        }
    };

    for (var _key in events) {
        _loop2(_key);
    }

    // Init Share Logic
    share.init(this, config.debug);

    wechatApis = wechatApis.concat(share.wechatApis);

    ready(function () {
        if (config.wechatSupport && sniff.browsers.wechat) {
            wechatEnv(config, wechatApis, function (bridge) {
                if (bridge) {
                    _this.bridge = bridge;
                    _this.env = 'wechat';
                    if (sniff.android) {
                        cacheUrl = getUrl();
                        window.addEventListener('popstate', function () {
                            var curUrl = getUrl();
                            if (cacheUrl !== curUrl) {
                                cacheUrl = curUrl;
                                _this.isReady = false;
                                wechatEnv(config, wechatApis, doReady);
                            }
                        }, false);
                    }
                }
                doReady();
            });
        } else if (!config.hytiveReg || sniff.hy) {
            hyEnv(config, function (bridge) {
                if (bridge) {
                    (function () {
                        sniff.hy = true;
                        _this.bridge = bridge;
                        _this.env = 'hy';
                        var uploadImage = _this.uploadImage;
                        var successData = [];
                        var id = 0;
                        _this.uploadImage = _this.hy.uploadImage = function (opt) {
                            var localIds = opt.localIds,
                                success = opt.success;

                            if (localIds && Array.isArray(localIds)) {
                                (function () {
                                    var upload = function upload(id) {
                                        if (id === localIds.length) {
                                            success({ data: successData });
                                            return;
                                        }
                                        opt.localId = localIds[id];
                                        opt.success = function (res) {
                                            successData.push(res);
                                            id++;
                                            upload(id);
                                        };
                                        uploadImage(opt);
                                    };
                                    upload(id);
                                })();
                            } else {
                                uploadImage(opt);
                            }
                        };
                    })();
                }
                doReady();
            });
        } else {
            doReady();
        }
    });
};


//////////////////
// WEBPACK FOOTER
// ../src/init.js
// module id = 3
// module chunks = 0 2 4